import { useQuery } from "@apollo/client";
import { useGetContractIdData } from "providers/ContractIdProvider";
import { useKeycloak } from "providers/KeycloakProvider";
import { CONTACT_TAGS_QUERY, ContactTagsQuery } from "./types";

const PAGE_TAG_PREFIX = "Finansportalen" as const;

export const useGetContactPages = () => {
  const { linkedContact } = useKeycloak();
  const { selectedContactId } = useGetContractIdData();

  const { loading, error, data } = useQuery<ContactTagsQuery>(
    CONTACT_TAGS_QUERY,
    {
      variables: {
        contactId: selectedContactId || linkedContact,
      },
      fetchPolicy: "cache-first",
    }
  );

  return {
    loading,
    error,
    data: data?.contact.tagsAsSet?.filter((tag) =>
      tag.includes(PAGE_TAG_PREFIX)
    ),
  };
};
